import {mapGetters} from 'vuex';
import motime from '../../../common/utilities/motime';

export default {
    name: 'propertyTags',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb', 'favoriteListings', 'getSplit', 'hasAgent']),
        ...mapGetters('dpp', ['dpp', 'getEstRentFee', 'getMonthTotal']),
        isFavorite() {
            return this.favoriteListings.indexOf(this.dpp.propertyId) !== -1;
        },
        goodInvestment() {
            if (this.dpp.isRentals || !this.dpp.isActive) {
                return false;
            }
            if (this.getEstRentFee && this.getMonthTotal && (this.dpp.closePrice > 0 || this.dpp.listPrice > 0)) {
                return this.getEstRentFee.value > this.getMonthTotal;
            }
            return false;
        },
        gethousestatus() {
            if (this.dpp.isNewDpp) {
                if (!this.dpp.isActive && this.dpp.soldDate) {
                    let text = 'Sold';
                    if (this.dpp.soldDate && !this.dpp.hideDaysOnMarket) {
                        return `${text} on ${motime.formatDate(this.dpp.soldDate)}`;
                    }
                    return text;
                }
                return '';
            }
            if(this.dpp.showAsPR) return 'Not For Sale / Not For Rent';
            if(this.dpp.houseRealStatus === this.glb.propertyStatus.offMarket) return 'Off Market';
            if(this.dpp.houseRealStatus === this.glb.propertyStatus.removed) return 'Removed';
            if(this.dpp.houseRealStatus === this.glb.propertyStatus.sold) {
                let text = 'Sold'
                if (this.dpp.soldDate && !this.dpp.hideDaysOnMarket) {
                    return `${text} on ${motime.formatDate(this.dpp.soldDate)}`;
                }
                return text
            }
        },
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        showAgentTag() {
            const compliance = this.getComplianceMethod()();
            if (compliance[0] && compliance[0].rule.indexOf('showAgentOnFirstPage') >= 0) {
                return true;
            }
            return false;
        },
        showAgentContactTag() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule.indexOf('showAgentContactOnPhoto') >= 0;
        },
        shouldShowHistoryLogo() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule.indexOf('hideHistoryLogo') === -1;
        },
        popPhotoView() {
            this.$eventBus.$emit('property-pop-photo', { cateIndex: 0, photoIndex: 0, single: !this.glb.isPhone });
        },
        pop3d(url) {
            this.$eventBus.$emit('property-pop-3d', url);
        },
        popSoldlead() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadTitle: ' ',
                    hotleadType: 'hotHomeHotLead',
                    buttonText: 'Send Request',
                    showComment: false,
                    propertyId: this.dpp.propertyId,
                    propertyData: this.dpp,
                },
            });
        },
        openVirtualTour() {
            var hotleadOpt = {
                hotleadType: 'VirtualTourHotleadInResponsiveDPP',
                propertyId: this.dpp.propertyId,
                propertyData: this.dpp,
            };
            if (this.glb.agent.id) {
                hotleadOpt.ojoFormConfigs = {
                    showCtaLinks: true,
                    showOJOagentInfo: true,
                    showDisclaimer: false,
                    commnetLabel: 'Message',
                };
            }
            this.$eventBus.$emit('dialog-center', { name: 'mvtHotleadForm', trigger: this.$options.name, opt: hotleadOpt });
        },
        popOpenHouse() {
            this.$eventBus.$emit('property-openhouse', { hotleadType: 'OpenHouseHeroPill' });
        },
        addFavorite() {
            this.$eventBus.$emit('eventbus-action-save-home');
        },
        shareAction() {
            this.$eventBus.$emit('property-share');
        },
    },
};